/**
 * 학습 시나리오(인트로 → 가입·로그인 → 강의 선택 → 단계별 학습)와 동일한 단계 명·설명.
 * 강의 상세 목차(`useLectureDetail`)에서 사용합니다.
 */
export const LECTURE_SCENARIO_STEPS = [
  {
    id: 1,
    title: '문제 풀이',
    subtitle: '문제지에 펜으로 직접 풀이',
    completed: false,
    type: 'quiz',
  },
  {
    id: 2,
    title: '강의',
    subtitle: '해설 영상을 보고 메모',
    completed: false,
    type: 'lecture',
  },
  {
    id: 3,
    title: 'AI 첨삭',
    subtitle: '독해 · 사고 · 표현 · 밑줄',
    completed: false,
    type: 'assignment',
  },
  {
    id: 4,
    title: '강사 첨삭',
    subtitle: '선생님 피드백 확인',
    completed: false,
    type: 'assessment',
  },
  {
    id: 5,
    title: '리라이팅',
    subtitle: '표준답안과 비교해 다시 쓰기',
    completed: false,
    type: 'final',
  },
];
